import { render, staticRenderFns } from "./StatusBar.vue?vue&type=template&id=84795040"
import script from "./StatusBar.vue?vue&type=script&lang=js"
export * from "./StatusBar.vue?vue&type=script&lang=js"
import style0 from "./StatusBar.vue?vue&type=style&index=0&id=84795040&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports